import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { AdminSidebar } from './components/AdminSidebar';
import { AdminHeader } from './components/AdminHeader';
import { adminTheme } from './styles/adminTheme';

const LayoutContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;

const RightArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  background: ${adminTheme.colors.contentBg};
  padding: ${adminTheme.spacing.pagePadding}px;
`;

interface AdminLayoutProps {
  username: string;
  onLogout: () => void;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ username, onLogout }) => {
  return (
    <LayoutContainer>
      <AdminSidebar />
      <RightArea>
        <AdminHeader username={username} onLogout={onLogout} />
        <Content>
          <Outlet />
        </Content>
      </RightArea>
    </LayoutContainer>
  );
};
